/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Syslog-сервера
 */

/**
 * Сервис управления настройками Syslog-сервера
 */
export class SyslogSettingsServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек Syslog-сервера
   */
  EditSyslogSettings = (req: Pick<EditSyslogSettingsRequestDto, "updateMask"> & { data: SyslogSettingsRequestDto & fm.RequireAtLeastOne<SyslogSettingsRequestDto> }, init?: RequestInit): Promise<EditSyslogSettingsResponseDto> => {
    return fm.request<Pick<EditSyslogSettingsRequestDto, "updateMask"> & { data: SyslogSettingsRequestDto & fm.RequireAtLeastOne<SyslogSettingsRequestDto> }, EditSyslogSettingsResponseDto>(`${this.host}/device/api/v1/syslog/settings`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек Syslog-сервера
   */
  GetSyslogSettings = (req?: GetSyslogSettingsRequestDto, init?: RequestInit): Promise<GetSyslogSettingsResponseDto> => {
    return fm.request<GetSyslogSettingsRequestDto, GetSyslogSettingsResponseDto>(`${this.host}/device/api/v1/syslog/settings${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Уровень логирования
 */
export enum SyslogSettingsLogLevelType {
  /**
   * Значение не указано
   */
  LOG_LEVEL_TYPE_UNKNOWN = "LOG_LEVEL_TYPE_UNKNOWN",
  /**
   * Система не пригодна для использования
   */
  EMERGENCY = "EMERGENCY",
  /**
   * Требуются немедленные меры
   */
  ALERT = "ALERT",
  /**
   * Сообщение о критическом состоянии
   */
  CRIT = "CRIT",
  /**
   * Сообщение об ошибочном состоянии
   */
  ERROR = "ERROR",
  /**
   * Предупреждение
   */
  WARN = "WARN",
  /**
   * Сообщение о значительном нормальном событии
   */
  NOTE = "NOTE",
  /**
   * Информационное сообщение
   */
  INFO = "INFO",
  /**
   * Сообщение отладочного уровня
   */
  DEBUG = "DEBUG",
}
/**
 * Уровень логирования
 */
export type SyslogSettingsLogLevelTypeResponseEnum = keyof typeof SyslogSettingsLogLevelType
/**
 * Уровень логирования
 */
export type SyslogSettingsLogLevelTypeRequestEnum = Exclude<SyslogSettingsLogLevelTypeResponseEnum, "LOG_LEVEL_TYPE_UNKNOWN">;

/**
 * Тип протокола
 */
export enum SyslogSettingsProtocolType {
  /**
   * Значение не указано
   */
  PROTOCOL_TYPE_UNKNOWN = "PROTOCOL_TYPE_UNKNOWN",
  /**
   * Протокол UDP
   */
  UDP = "UDP",
  /**
   * Протокол TCP
   */
  TCP = "TCP",
}
/**
 * Тип протокола
 */
export type SyslogSettingsProtocolTypeResponseEnum = keyof typeof SyslogSettingsProtocolType
/**
 * Тип протокола
 */
export type SyslogSettingsProtocolTypeRequestEnum = Exclude<SyslogSettingsProtocolTypeResponseEnum, "PROTOCOL_TYPE_UNKNOWN">;

/**
 * Запрос редактирования настроек Syslog-сервера
 */
export type EditSyslogSettingsRequestDto = {
  /**
   * Настройки Syslog-сервера
   */
  data: SyslogSettingsRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек Syslog-сервера
 */
export type EditSyslogSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Syslog-сервера
   */
  readonly data: SyslogSettingsResponseDto
  /**
   * Ошибка
   */
  readonly error: EditSyslogSettingsResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditSyslogSettingsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditSyslogSettingsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек Syslog-сервера
 */
export type GetSyslogSettingsRequestDto = {
}
/**
 * Ответ на запрос получения настроек Syslog-сервера
 */
export type GetSyslogSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Syslog-сервера
   */
  readonly data: SyslogSettingsResponseDto
}>
/**
 * Настройки Syslog-сервера
 */
export type SyslogSettingsRequestDto = {
  /**
   * Тип протокола
   */
  protocolType?: SyslogSettingsProtocolTypeRequestEnum | "PROTOCOL_TYPE_UNKNOWN"
  /**
   * Адрес Syslog-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:514, syslog.acme.io:6514
   */
  address?: string
  /**
   * Уровень логирования
   */
  logLevelType?: SyslogSettingsLogLevelTypeRequestEnum | "LOG_LEVEL_TYPE_UNKNOWN"
}
/**
 * Настройки Syslog-сервера
 */
export type SyslogSettingsResponseDto = {
  /**
   * Тип протокола
   */
  protocolType: SyslogSettingsProtocolTypeResponseEnum
  /**
   * Адрес Syslog-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:514, syslog.acme.io:6514
   */
  address: string
  /**
   * Уровень логирования
   */
  logLevelType: SyslogSettingsLogLevelTypeResponseEnum
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек Syslog-сервера
   */
  "EditSyslogSettingsRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек Syslog-сервера",
    "fields": {
      /**
       * Настройки Syslog-сервера
       */
      "data": {
        "type": "SyslogSettings",
        "text": "Настройки Syslog-сервера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек Syslog-сервера
   */
  "EditSyslogSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек Syslog-сервера",
    "fields": {
      /**
       * Настройки Syslog-сервера
       */
      "data": {
        "type": "SyslogSettings",
        "text": "Настройки Syslog-сервера",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "EditSyslogSettingsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditSyslogSettingsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек Syslog-сервера
   */
  "GetSyslogSettingsRequest": {
    "kind": "class",
    "text": "Запрос получения настроек Syslog-сервера",
  },
  /**
   * Ответ на запрос получения настроек Syslog-сервера
   */
  "GetSyslogSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек Syslog-сервера",
    "fields": {
      /**
       * Настройки Syslog-сервера
       */
      "data": {
        "type": "SyslogSettings",
        "text": "Настройки Syslog-сервера",
      },
    },
  },
  /**
   * Настройки Syslog-сервера
   */
  "SyslogSettings": {
    "kind": "class",
    "text": "Настройки Syslog-сервера",
    "fields": {
      /**
       * Тип протокола
       */
      "protocolType": {
        "type": "SyslogSettings.ProtocolType",
        "text": "Тип протокола",
      },
      /**
       * Адрес Syslog-сервера.
       * Сетевой адрес и порт.
       * Пример: 192.168.0.1:514, syslog.acme.io:6514
       */
      "address": {
        "type": "string",
        "text": "Адрес Syslog-сервера.\nСетевой адрес и порт.\nПример: 192.168.0.1:514, syslog.acme.io:6514",
      },
      /**
       * Уровень логирования
       */
      "logLevelType": {
        "type": "SyslogSettings.LogLevelType",
        "text": "Уровень логирования",
      },
    },
  },
  /**
   * Уровень логирования
   */
  "SyslogSettings.LogLevelType": {
    "kind": "enum",
    "text": "Уровень логирования",
    "values": {
      /**
       * Значение не указано
       */
      "LOG_LEVEL_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Система не пригодна для использования
       */
      "EMERGENCY": {
        "i": 1,
        "text": "Система не пригодна для использования",
      },
      /**
       * Требуются немедленные меры
       */
      "ALERT": {
        "i": 2,
        "text": "Требуются немедленные меры",
      },
      /**
       * Сообщение о критическом состоянии
       */
      "CRIT": {
        "i": 3,
        "text": "Сообщение о критическом состоянии",
      },
      /**
       * Сообщение об ошибочном состоянии
       */
      "ERROR": {
        "i": 4,
        "text": "Сообщение об ошибочном состоянии",
      },
      /**
       * Предупреждение
       */
      "WARN": {
        "i": 5,
        "text": "Предупреждение",
      },
      /**
       * Сообщение о значительном нормальном событии
       */
      "NOTE": {
        "i": 6,
        "text": "Сообщение о значительном нормальном событии",
      },
      /**
       * Информационное сообщение
       */
      "INFO": {
        "i": 7,
        "text": "Информационное сообщение",
      },
      /**
       * Сообщение отладочного уровня
       */
      "DEBUG": {
        "i": 8,
        "text": "Сообщение отладочного уровня",
      },
    },
  },
  /**
   * Тип протокола
   */
  "SyslogSettings.ProtocolType": {
    "kind": "enum",
    "text": "Тип протокола",
    "values": {
      /**
       * Значение не указано
       */
      "PROTOCOL_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Протокол UDP
       */
      "UDP": {
        "i": 1,
        "text": "Протокол UDP",
      },
      /**
       * Протокол TCP
       */
      "TCP": {
        "i": 2,
        "text": "Протокол TCP",
      },
    },
  },
}